<template>
  <button
    class="base-button-type-1"
    :class="{ blue: typeColor == 'blue', white: typeColor == 'white' }"
    v-on="listeners"
    v-text="text"
  ></button>
</template>

<script>
export default {
  name: 'base-button-type-1',
  props: {
    text: {
      default: 'BUTTON TEXT',
      type: String
    },
    typeColor: {
      default: 'blue',
      type: String
    }
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.base-button-type-1 {
  width: 150px;
  height: 50px;
  font-size: 14px;
  font-weight: 300;
  letter-spacing: 1px;
  cursor: pointer;
  outline: none;

  &.blue {
    border: 0;
    background-color: #000bff;
    color: white;
  }

  &.white {
    background-color: white;
    border: 1px solid #c8c8c8;
    &:active {
      color: #000000;
    }
  }
}
</style>
